<template>
    <div class="flex bg-gray-100 border p-2 rounded mr-4 " style="width: 200px">
        <selectable-input :value="isPageSelected" @toggle="togglePage" /> <span style="white-space: nowrap;" class="pl-2 pr-2">{{ selectedFormatted }} selected</span>
        <div class="flex justify-end w-full">
            <span @click="clearSelection"
                class="bg-red-500 text-gray-100 rounded-full p-1 ml-1 hover:bg-red-600 hover:text-gray-100 cursor-pointer h-6 w-6 flex items-center justify-center transition-colors duration-300 ease-in-out"
                style="height: 22px; width: 22px; min-width: 22px;"
            >
                <font-awesome-icon  :icon="['fas', 'xmark']"
                ></font-awesome-icon>
            </span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';
import SelectableInput from './SelectableInput.vue';
import _ from 'lodash';

export default {
    name: 'SelectAll',
    components: {
        SelectableInput,
    },
    data: () => ({
    }),
    computed: {
        ...mapWritableState(useGeneralTableStore, ['selected', 'page', 'data', 'items', 'total']),
        isPageSelected() {
            if (!this.items.length || !this.selected.length) return false;
            return this.items.every(item => this.selected.find(selectedItem => selectedItem[this.id] == item[this.id]));
        },
        selectedFormatted() {
            return this.selected.length.toLocaleString();
        },
        id() {
            //see if the first item uses tra_id or not
            return this.items.length ? this.items[0].tra_id ? 'tra_id' : 'id' : 'id';
        }
    },
    methods: {
        togglePage() {
            if (this.isPageSelected) {
                if (this.selected.length == this.total) {
                    // If all items are selected, clear the selection
                    this.clearSelection();
                } else {
                    // Remove items from selected that are in the current page (items
                    this.selected = this.selected.filter(item => !this.items.find(pageItem => pageItem[this.id] == item[this.id]));
                }
            } else {
                this.selected = _.uniqBy([...this.selected, ...this.items], this.id);
            }

           // this.$store.toggleAll();
        },
        clearSelection() {
            this.selected = [];
        }
    }
}

</script>